import { useQuery } from "@tanstack/react-query";
import { useState } from "react"
import { useLocation } from "react-router-dom";
import { genericGet } from "../../services/api.service";
import { EntregasDisplay } from "./EntregasDisplay";
import { EntregasForm } from "./EntregasForm";


export function Entrega() {

    const [editing, setEditing] = useState(false);
    const location = useLocation();

    const {data : entrega, refetch} = useQuery({
        queryKey: ['entrega'],
        queryFn: async () => {
            return await genericGet(location.pathname);
        }
    })


    return (<div>
        {entrega ?
        <>
            {editing ? <EntregasForm entrega={entrega} onCancel={()=> {
                setEditing(false)
                refetch();
                }}/> : <EntregasDisplay refetchEntrega={refetch} entrega={entrega} setEditing={()=> setEditing(true)}/>}
        </>
        : null}
        
    </div>)


}